import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";
import { crudResult } from '../../dataContracts';

const dealershipRequest = (data) => ({
  ...(data || {}),
  requestedApp: "dealership_web",
});

const callableError = (error, message) => {
  notifyPermissionDenied(error);
  if (/permission-denied|unauthenticated/.test(error.code || '')) throw error;
  return { success: "no", message, error: error.message, code: error.code || null };
};

export const getCustomerByDni = async (data) => {
  try {
    const fn = httpsCallable(functions, "getCustomerByDniV2");
    const result = await fn(dealershipRequest(data));
    return crudResult(result.data);
  } catch (error) {
    console.error("Error buscando cliente por DNI:", error);
    return callableError(error, "Error al buscar cliente por DNI");
  }
};

export const createCustomer = async (data) => {
  try {
    const fn = httpsCallable(functions, "createCustomerV2");
    const result = await fn(dealershipRequest(data));
    return crudResult(result.data);
  } catch (error) {
    console.error("Error creando cliente:", error);
    return callableError(error, "Error al crear cliente");
  }
};

export const resolveCustomerIdentity = async (data) => {
  try {
    const fn = httpsCallable(functions, "resolveCustomerIdentityV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.warn("Error resolviendo identidad en ARCA:", error);
    notifyPermissionDenied(error);
    return { success: "no", message: error.message, error: error.message, code: error.code || null };
  }
};
